import React, {useState}                    from "react";
import { useNavigate }                      from "react-router-dom";


// This will manage the modal state globally
let showBtnExitCallback = null;
let hideBtnExitCallback = null;

export const useBtnExit = () => {
  return { showBtnExit: showBtnExitCallback, hideBtnExit: hideBtnExitCallback};
};
export const MainElement = ({clickAction, parentElement: Parent, childrenElement}) => {
        return(
            <Parent onClick={clickAction}>
                {childrenElement}
            </Parent>
        );
};
// #region exit button
export const BtnExit = React.memo(() => {
    const navigate              = useNavigate();
    const [display, setDisplay] = useState(false);
    const [content, setContent] = useState({ return_path: '', fragmentPosition: <></>, fragmentContent: <></> });

    showBtnExitCallback = ({ return_path, fragmentPosition,  fragmentContent}) => {
        setContent({ return_path, fragmentPosition,  fragmentContent });
        setDisplay(true);
    };
    hideBtnExitCallback = () => {
        setDisplay(false);
        setContent({ return_path: '', fragmentPosition: <></>, fragmentContent: <></> });
    };

    const redirectAction = () => {
        navigate(content.return_path);
    };

    return (
        <>
            {display && (
                <MainElement 
                  clickAction={() => {redirectAction();}} 
                  parentElement={content.fragmentPosition}
                  childrenElement={content.fragmentContent}
                />
            )}
        </>
    );
});
